import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getCarts, getProducts } from "../store/actions/productAction";
import Product from "../components/content/Product";
import CartList from "../components/content/CartList";
import Navbar from "../components/layout/Navbar";

const Products = () => {
  const dispatch = useDispatch();

  const [cart, setCart] = useState([]);

  const products = useSelector((state) => state.product.filterProducts);
  const data = useSelector((state) => state.product.cart);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (products.length && data.length) {
      const copy = data.map((item) => {
        return {
          ...item,
          product: products.find((product) => product._id === item.productId),
        };
      });

      setCart([...copy]);
    }
  }, [products, data]);

  useEffect(() => {
    dispatch(getProducts());
    dispatch(getCarts());
  }, []);

  return (
    <div id="products">
      <Navbar searchButton />
      {products.length === 0 ? (
        <>
          <div className="row justify-content-center align-items-center h-80vh">
            <i
              className="fa fa-spinner fa-pulse fa-3x fa-fw"
              style={{ color: "blue" }}
            ></i>
            <span className="sr-only">Loading...</span>
          </div>
        </>
      ) : (
        <div className="row mt-5">
          <div className="col">
            <div className="row">
              {products.map((product) => (
                <Product key={product._id} product={product} />
              ))}
            </div>
          </div>
          {isAuthenticated && cart.length !== 0 && (
            <>
              <div className="col-lg-3 col-sm-12">
                <CartList cart={cart} checkoutButton />
              </div>
            </>
          )}
          )
        </div>
      )}
    </div>
  );
};

export default Products;
